import { Button } from '@mui/material';
import { useEffect } from 'react';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import { useNavigate } from 'react-router';
import { useProfile } from '@/hooks/useProfile';
import { useTranslation } from 'react-i18next';
import { ThemedTooltip } from '@/components/chat/FeedbackContainer';
import { readStaffProfile } from '@/util/staffUtils';
const StaffButton = () => {
  const { t } = useTranslation(['auth']);
  const isStaff = process.env.REACT_APP_ENV === 'staff';
  const { setProfile, setProfileImage } = useProfile();
  const navigate = useNavigate();
  const goToStaffFun = () => {
    localStorage.clear();
    setProfile(null);
    setProfileImage(undefined);
    return navigate('/staff');
  };
  useEffect(() => {
    if (isStaff) {
      // Mirrors ProfileProvider: a cached profile from an older build is not
      // trusted, so it is not re-injected here either.
      const storedProfile = readStaffProfile();
      const profileImageState = localStorage.getItem('profileStaffImage');
      if (storedProfile && profileImageState) {
        setProfile(storedProfile);
        setProfileImage(JSON.parse(profileImageState));
      }
    }
  }, [isStaff, setProfile, setProfileImage]);
  if (!isStaff) return null;
  return (
    <ThemedTooltip title={t('goToStaff')} data-testid="staff-button-tooltip">
      <Button
        variant="contained"
        onClick={goToStaffFun}
        data-testid="staff-button"
        sx={{
          position: 'absolute',
          width: '60px',
          height: '60px',
          top: { xs: '52px', lg: '12px' },
          right: '20px',
          borderRadius: '100%',
          zIndex: '100000',
        }}
      >
        <SupportAgentIcon fontSize="large" data-testid="staff-button-icon" />
      </Button>
    </ThemedTooltip>
  );
};

export default StaffButton;
